var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-page"},[_c('div',{staticClass:"sginup"},[_c('div',{staticClass:"left"}),_vm._v(" "),_c('div',{staticClass:"btn",on:{"click":_vm.handleSignup}},[_vm._v("代表团报名")])]),_vm._v(" "),_c('div',{staticClass:"main"},[_c('router-view')],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53858532","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/district/views/delegation/Home.vue
// module id = null
// module chunks = 